import { styled } from '@mui/system'
import { ListItemText } from '@mui/material'

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  marginBottom: 12,
  '&:last-child': {
    marginBottom: 0,
  },
}))
